/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/href-no-hash */
import React, { Component } from 'react';
import {
  Button,
  Form,
  Dropdown,
  Modal,
  Grid,
  Divider,
  Loader,
  Label,
  Icon
} from 'semantic-ui-react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import * as AppActions from '../../actions';
import { getProperThumbnail } from '../../utils/thumbnailRecovery';
import {
  insertPackage,
  updatePackage,
  getPackage
} from '../../services/PackageServiceManager';
import ModalCampaign from './ModalCampaign';
import AdSetList from './AdSetList';
import CampaignList from './CampaignList';
import AdList from './AdList';
import './ManagePackage.css';

const descriptionOptions = [
  {
    key: 0,
    text: 'At dealership',
    value: 'At {{vehicle.dealer_name}}'
  },
  {
    key: 1,
    text: 'Vehicle price',
    value: '{{vehicle.price}}'
  },

  {
    key: 2,
    text: 'VIN number',
    value: '{{vehicle.vehicle_id}}'
  },
  {
    key: 3,
    text: 'Click to View Price',
    value: 'Click to View Price'
  }
];

class ManagePackage extends Component {
  state = {
    errorMessage: '',
    objectiveOptions: [],
    message: '',
    selectedTags: '',
    showModalCampaign: false,
    packageIdToEdit: null,
    processing: false,
    form: {
      packageName: '',
      oems: [],
      campaigns: [],
      adsets: [],
      ads: [],
      description: '',
      startDate: '',
      endDate: ''
    },
    currentSingleThumbnails: [],
    changesWereMade: false
  };

  componentDidMount() {
    this.fillObjectives();
    if (this.props.packageToEdit) {
      this.initializeEdit(this.props.packageToEdit);
    }
  }

  initializeEdit = async (packageToEdit) => {
    const { adPrototypes, getFbToken } = this.props;
    const token = getFbToken ? getFbToken() : '';
    const { package: packageObj, campaigns, adsets, ads } = packageToEdit;
    const {
      name: packageName = '',
      product_description: description = '',
      start_date: startDate = '',
      end_date: endDate = '',
      oem = null
    } = packageObj || {};

    ads.forEach((ad) => {
      if (ad.type === 'Cinemagraph' && ad.name.includes('_Video_')) {
        // eslint-disable-next-line no-param-reassign
        ad.name = ad.name.replace('_Video_', '_Cinemagraph_');
      }
    });

    const form = {
      ...this.state.form,
      packageName,
      campaigns,
      adsets,
      ads,
      description,
      startDate: startDate ? new Date(startDate) : '',
      endDate: endDate ? new Date(endDate) : ''
    };

    form.ads.forEach((ad) => {
      const adPrototype = adPrototypes.find(
        (item) => item.id === parseInt(ad.ad_prototype_id, 10)
      );

      if (!adPrototype) {
        return;
      }

      if (adPrototype.type === 'Cinemagraph' && ad.name.includes('_Video_')) {
        ad.name = ad.name.replace('_Video_', '_Cinemagraph_');
      } else if (
        adPrototype.type === 'Video' &&
        ad.name.includes('_Cinemagraph_')
      ) {
        ad.name = ad.name.replace('_Cinemagraph_', '_Video_');
      }

      ad.ad = adPrototype;
    });

    const oems = [];
    if (oem) {
      form.oems = [];
      oem.split(',').forEach((item) => {
        const tag = this.props.tags.find((tagProp) => tagProp.text === item);
        if (tag) {
          oems.push(tag.value);
          form.oems.push(tag);
        }
      });
    }

    this.setState(
      {
        form,
        selectedTags: oems,
        packageIdToEdit: packageToEdit.package.id
      },
      () => {
        const { adsets: formAdsets, ads: formAds } = this.state.form;
        formAdsets.forEach((adset) => {
          formAds
            .filter((item) => item.adSetId === adset.id)
            .forEach((ad) => {
              const currentAd = ad.ad;
              getProperThumbnail(
                currentAd,
                'ad',
                this.setThumbnailArrayState,
                token
              );
            });
        });
      }
    );
  };

  generateNewId = () => {
    return (
      Math.random()
        .toString(36)
        .substring(2, 15) +
      Math.random()
        .toString(36)
        .substring(2, 15)
    );
  };

  fillObjectives = () => {
    const objectiveOptions = [
      { key: 0, value: 'CONVERSIONS', text: 'Conversion' },
      { key: 0, value: 'LINK_CLICKS', text: 'Traffic' },
      { key: 1, value: 'PRODUCT_CATALOG_SALES', text: 'DAA' },
      { key: 2, value: 'VIDEO_VIEWS', text: 'Video Views' }
    ];
    this.setState({ objectiveOptions });
  };

  goBackSearch = () => {
    this.props.searchPage();
  };

  savePackage = () => {
    const { user } = this.props;
    const { packageIdToEdit, form } = this.state;
    const {
      packageName,
      oems,
      campaigns,
      adsets,
      ads,
      description,
      startDate,
      endDate
    } = form;

    this.setState(
      {
        errorMessage: '',
        message: '',
        processing: true,
        changesWereMade: false
      },
      async () => {
        if (!packageName) {
          this.setState((prevState) => ({
            ...prevState,
            errorMessage: 'The package name is required',
            processing: false
          }));
          return;
        }

        const oemsValues = oems.map((o) => o.text).join(',');

        const packageData = {
          name: packageName,
          oem: oemsValues,
          user: user.email.trim(),
          product_description: description,
          start_date: startDate,
          end_date: endDate,
          campaigns,
          adsets,
          ads
        };

        if (packageIdToEdit) {
          packageData.id = packageIdToEdit;
        }

        const result = !packageIdToEdit
          ? await insertPackage(packageData)
          : await updatePackage(packageData);

        if (result.statusCode === 200) {
          const message = !packageIdToEdit
            ? 'The Package has been created'
            : 'The Package has been updated';

          if (!packageIdToEdit) {
            this.setState((prevState) => ({
              ...prevState,
              form: {
                packageName: '',
                oems: [],
                campaigns: [],
                adsets: [],
                ads: [],
                description: ''
              },
              selectedTags: '',
              message,
              processing: false,
              changesWereMade: false
            }));
          } else {
            const id = result.id;
            this.setState({ packageIdToEdit: id }, async () => {
              const updatedPackage = await getPackage(id);
              this.initializeEdit(updatedPackage.packageData);
              this.setState((prevState) => ({
                ...prevState,
                message,
                processing: false,
                changesWereMade: false
              }));
            });
          }
        } else {
          this.setState((prevState) => ({
            ...prevState,
            errorMessage: 'There was an error saving the package',
            processing: false,
            changesWereMade: false
          }));
        }
      }
    );
  };

  handleFormChange = (event, { name, value }) => {
    this.setState((prevState) => ({
      ...prevState,
      form: { ...this.state.form, [name]: value || '' },
      changesWereMade: true
    }));
  };

  selectDate = (date, day) => {
    const form = { ...this.state.form };
    form[date] = day;
    this.setState({ ...this.state, form });
  };

  onOemSelect = (e, { value, options }) => {
    const tags = [];

    value.forEach((val) => {
      const tag = _.find(options, (option) => {
        return option.value === val;
      });

      if (tag) {
        tags.push(tag);
      }
    });

    const form = this.state.form;
    form.oems = tags;

    this.setState((prevState) => ({
      ...prevState,
      form,
      selectedTags: value,
      changesWereMade: true
    }));
  };

  openCampaignModal = () => {
    this.setState((prevState) => ({ ...prevState, showModalCampaign: true }));
  };

  onCloseModalCampaign = () => {
    this.setState((prevState) => ({ ...prevState, showModalCampaign: false }));
  };

  addCampaign = (campaign) => {
    const campaignToPush = campaign;
    const form = { ...this.state.form };
    campaignToPush.id = this.generateNewId();
    form.campaigns.push(campaignToPush);
    this.setState((prevState) => ({
      ...prevState,
      showModalCampaign: false,
      form,
      changesWereMade: true
    }));
  };

  addAdset = (adset) => {
    const adSetToPush = adset;
    const form = { ...this.state.form };

    if (!adset.id) {
      adSetToPush.id = this.generateNewId();
      form.adsets.push(adSetToPush);
    } else {
      const adsetToEdit = form.adsets.find((item) => item.id === adset.id);
      const index = form.adsets.indexOf(adsetToEdit);
      if (index > -1) {
        form.adsets[index] = adset;
      }
    }

    form.ads
      .filter((item) => item.adSetId === adset.id)
      .forEach((ad) => {
        const adNameParts = ad.name.split('_');
        // eslint-disable-next-line no-param-reassign
        ad.name = `${adset.adSetName}_${adNameParts[adNameParts.length - 2]}_${
          adNameParts[adNameParts.length - 1]
        }`;
      });

    this.setState((prevState) => ({
      ...prevState,
      form,
      changesWereMade: true
    }));
  };

  addAd = (ad) => {
    const adToPush = ad;
    const form = { ...this.state.form };

    if (!ad.id) {
      adToPush.id = this.generateNewId();
      form.ads.push(adToPush);
    } else {
      const adToEdit = form.ads.find((item) => item.id === ad.id);
      const index = form.ads.indexOf(adToEdit);
      if (index > -1) {
        form.ads[index] = ad;
      }
    }

    this.setState((prevState) => ({
      ...prevState,
      form,
      changesWereMade: true
    }));
  };

  changeCampaignValue = (id, name, value) => {
    const form = this.state.form;
    const campaign = form.campaigns.find((item) => item.id === id);
    const index = form.campaigns.indexOf(campaign);
    campaign[name] = name === 'is_hec_campaign' ? !value : value;
    form.campaigns[index] = campaign;
    this.setState((prevState) => ({
      ...prevState,
      form,
      changesWereMade: true
    }));
  };

  removeCampaign = (id) => {
    const form = { ...this.state.form };
    const campaign = form.campaigns.find((item) => item.id === id);
    const index = form.campaigns.indexOf(campaign);
    if (index > -1) {
      form.campaigns.splice(index, 1);
    }

    this.setState((prevState) => ({
      ...prevState,
      form,
      changesWereMade: true
    }));
  };

  removeAdset = (id) => {
    const form = { ...this.state.form };
    const adset = form.adsets.find((item) => item.id === id);
    const index = form.adsets.indexOf(adset);
    if (index > -1) {
      form.adsets.splice(index, 1);
    }

    this.setState((prevState) => ({
      ...prevState,
      form,
      changesWereMade: true
    }));
  };

  removeAd = (id) => {
    const form = { ...this.state.form };
    const ad = form.ads.find((item) => item.id === id);
    const index = form.ads.indexOf(ad);
    if (index > -1) {
      form.ads.splice(index, 1);
    }

    this.setState((prevState) => ({
      ...prevState,
      form,
      changesWereMade: true
    }));
  };

  copyAdset = (adset) => {
    const form = { ...this.state.form };
    const ads = form.ads.filter((ad) => ad.adSetId === adset.id);

    const newAdset = Object.assign({}, adset);
    newAdset.id = this.generateNewId();
    form.adsets.push(newAdset);

    ads.forEach((ad) => {
      const newAd = Object.assign({}, ad);
      newAd.adSetId = newAdset.id;
      newAd.id = this.generateNewId();
      form.ads.push(newAd);
    });

    this.setState((prevState) => ({
      ...prevState,
      form,
      changesWereMade: true
    }));
  };

  setThumbnailArrayState = (adId, thumbnail) => {
    const { currentSingleThumbnails } = this.state;
    const newSingleThumbnails = [...currentSingleThumbnails];
    const newThumbnailObj = {
      adId,
      thumbnail
    };

    const foundThumbnailIndex = newSingleThumbnails.indexOf(
      (singleThumbnailObj) => {
        return singleThumbnailObj.adId === adId;
      }
    );

    if (foundThumbnailIndex !== -1) {
      newSingleThumbnails.splice(foundThumbnailIndex, 1);
    }
    newSingleThumbnails.push(newThumbnailObj);

    this.setState((prevState) => ({
      ...prevState,
      currentSingleThumbnails: newSingleThumbnails
    }));
  };

  closeChangesMadeMessage = () => {
    this.setState((prevState) => ({
      ...prevState,
      changesWereMade: false
    }));
  };

  render() {
    const {
      errorMessage,
      message,
      selectedTags,
      objectiveOptions,
      showModalCampaign,
      currentSingleThumbnails,
      processing,
      changesWereMade,
      form
    } = this.state;
    const {
      packageName,
      campaigns,
      adsets,
      ads,
      description,
      startDate,
      endDate
    } = form;
    const { tags, adPrototypes, audienceOptions } = this.props;
    return (
      <div>
        {processing ? (
          <div>
            <span>
              {' '}
              <Loader inline className="active" /> Processing...{' '}
            </span>
          </div>
        ) : null}
        {changesWereMade ? (
          <Button as="div" size="mini" labelPosition="left">
            <Label basic color="blue">
              Changes were made. Remember to save before exiting.
            </Label>
            <Button
              size="mini"
              color="blue"
              icon
              onClick={this.closeChangesMadeMessage}
            >
              <Icon name="close" />
            </Button>
          </Button>
        ) : null}
        <div className="manage-package-message-container">
          {errorMessage ? (
            <div>
              <Label basic color="red" className="manage-package-error">
                {errorMessage}
              </Label>
            </div>
          ) : null}
          {message ? (
            <div>
              <Label basic color="green" className="manage-package-message">
                {message}
              </Label>
            </div>
          ) : null}
        </div>
        <div className="manage-package-container">
          <div>
            <Button onClick={this.goBackSearch} size="small" color="grey">
              Back
            </Button>
            <Button onClick={this.savePackage} size="small" color="blue">
              Save
            </Button>
          </div>
          <div className="manage-package-form">
            <Form.Input
              placeholder="Package Name"
              type="text"
              name="packageName"
              value={packageName}
              onChange={this.handleFormChange}
            />
            <Dropdown
              placeholder="OEM(s)"
              search
              selection
              id="oem"
              multiple
              value={selectedTags}
              className="manage-package-oem"
              options={tags}
              onChange={this.onOemSelect}
            />
          </div>
        </div>
        <Divider hidden />
        <Grid>
          <Grid.Row columns={3}>
            <Grid.Column>
              <div>
                <span>
                  <b>Default Product Description</b>
                </span>
              </div>
              <Dropdown
                search
                selection
                clearable
                placeholder="At dealership"
                name="description"
                defaultValue={descriptionOptions[0].value}
                options={descriptionOptions}
                value={description}
                onChange={this.handleFormChange}
              />
            </Grid.Column>
            <Grid.Column>
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column>
                    <div>
                      <span>
                        <b>Start Date:</b>
                      </span>
                    </div>
                    <DayPickerInput
                      onDayChange={(day) => this.selectDate('startDate', day)}
                      value={startDate}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <div>
                      <span>
                        <b>End Date:</b>
                      </span>
                    </div>
                    <DayPickerInput
                      onDayChange={(day) => this.selectDate('endDate', day)}
                      value={endDate}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
          <Divider />
          <Grid.Row
            columns={3}
            style={{ border: 'solid rgba(192,192,192,0.3) 1px' }}
          >
            <Grid.Column className="manage-package-column-border">
              <div>
                <CampaignList
                  campaigns={campaigns}
                  objectiveOptions={objectiveOptions}
                  changeCampaignValue={this.changeCampaignValue}
                  removeCampaign={this.removeCampaign}
                />
              </div>
              <div>
                <a href="#" onClick={this.openCampaignModal}>
                  + New Campaign
                </a>
              </div>
            </Grid.Column>
            <Grid.Column className="manage-package-column-border">
              <div className="manage-package-campaign-list">
                <AdSetList
                  campaigns={campaigns}
                  adsets={adsets}
                  audienceOptions={audienceOptions}
                  addAdset={this.addAdset}
                  removeAdset={this.removeAdset}
                  copyAdset={this.copyAdset}
                />
              </div>
            </Grid.Column>
            <Grid.Column className="manage-package-column-border">
              <AdList
                adsets={adsets}
                campaigns={campaigns}
                ads={ads}
                addAd={this.addAd}
                adPrototypes={adPrototypes}
                removeAd={this.removeAd}
                currentSingleThumbnails={currentSingleThumbnails}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Modal
          dimmer={'inverted'}
          open={showModalCampaign}
          onClose={this.onCloseModalCampaign}
          size="small"
          className="modal-picker"
        >
          <Modal.Header>Add Campaign</Modal.Header>
          <Modal.Content>
            <ModalCampaign
              onCloseModalCampaign={this.onCloseModalCampaign}
              addCampaign={this.addCampaign}
              objectiveOptions={objectiveOptions}
            />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ManagePackage);



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/ManagePackage.js